import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = { class: "flex-grow-1 ms-2" }
const _hoisted_7 = { class: "fw-medium fs16 mb-0" }
const _hoisted_8 = { class: "fs-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4\"><h3 class=\"mb-0\">Recent Transactions</h3><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"clock\"></i> Today </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"pie-chart\"></i> Last 7 Days </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"rotate-cw\"></i> Last Month </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"calendar\"></i> Last 1 Year </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"bar-chart\"></i> All Time </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div></div>", 1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass([
            'd-flex align-items-center justify-content-between',
            transaction.className,
          ])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("i", {
                  class: _normalizeClass(["material-symbols-outlined icon-circle", [
                  transaction.iconColor,
                  transaction.iconBgColor,
                  'bg-opacity-10',
                  'text-center',
                  'rounded-circle',
                  'wh-40',
                  'lh-40',
                ]])
                }, _toDisplayString(transaction.icon), 3)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h6", _hoisted_7, _toDisplayString(transaction.name), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(transaction.date), 1)
              ])
            ]),
            _createElementVNode("span", {
              class: _normalizeClass([
              'fs-14 fw-medium',
              transaction.amount > 0 ? 'text-success' : 'text-danger',
            ])
            }, _toDisplayString(transaction.amount > 0
                ? `+${transaction.amount}`
                : transaction.amount), 3)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}